import { FelaCSS } from '../../../../components/fela/flowtypes';
import { colors } from '../../../../themes/variables';
import { ISharedProps as IStyleProps } from './suggestion-custom';

interface IStyles {
  wrapper: FelaCSS;
  missing: FelaCSS;
  getAdded: FelaCSS;
}

const styles = ({ notAButton }: IStyleProps): IStyles => {
  const wrapperPaddings: FelaCSS = notAButton
    ? {}
    : {
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingTop: '8px',
        paddingBottom: '8px',
        marginTop: '4px',
        background: 'none',
        border: 'none',
      };

  return {
    wrapper: {
      ...wrapperPaddings,
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      fontDefault: 14,
      lineHeight: '17px',
      borderRadius: '0',
      textAlign: 'left',

      ':hover': notAButton
        ? {}
        : {
            backgroundColor: colors.space04,
          },
    },

    missing: {
      paddingRight: '5px',
      marginBottom: '6px',
      fontDefaultSemiBold: 'inherit',
      color: colors.indigoCrush,
    },

    getAdded: {
      color: colors.space60,
      fontDefault: 'inherit',
    },
  };
};

export default styles;
